<template>
  <div class="Engineering_crumbs flex flex_ai_center">
    <div>
      <el-breadcrumb separator="/">
        <div class="floatLeft" style="margin-right:10px;">
          <img src="@/assets/public/tub.png" />
        </div>
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item @click="refreshPage">工队信息列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Breadcrumb',
  components: { },
  data () {
    return {}
  },
  computed: {},
  methods: {
    refreshPage () {
      // window.location.reload()
    }
  },
  watch: {},
  created () {},
  mounted () {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "@/styles/variable.scss";
 /* 面包屑 */
  .Engineering_crumbs {
    width: 1200px;
    height: 35px;
   line-height: 35px;
    margin: 0 auto;
    overflow: hidden;
    .colorBlack {
        color: #000000;
    }
  }
.el-icon-location {
    color: $default;
    margin-right: 5px;
}
.index{
    color: #0286df;

}
.refreshPage:hover{
    color: $default;
    cursor: pointer;
}
.floatLeft {
    float: left;
}
</style>
